import emptyPng from '@assets/empty.png';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@components/ui/tabs';
import { ETypeSearchItem } from '@enums/TypeSearchItem';
import { cn } from '@lib/ui/cn';
import { type IFindOutputData } from '@services/search/dtos/find/OutputData';
import SearchService from '@services/search/SearchService';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Link, useSearchParams } from 'react-router';

function SearchList() {
  const [searchParams] = useSearchParams();

  const { data } = useSuspenseQuery<IFindOutputData>({
    queryFn: async () => {
      const response = await SearchService.find({
        text: searchParams.get('q') || '',
      });
      return response;
    },
    queryKey: ['search', searchParams.get('q')],
    refetchOnWindowFocus: false,
  });

  return (
    <Tabs defaultValue="theme">
      <TabsList>
        <TabsTrigger
          className="data-[state=active]:text-tertiary text-background min-w-32 cursor-pointer"
          value="theme">
          Temas
        </TabsTrigger>
        <TabsTrigger
          className="data-[state=active]:text-tertiary text-background min-w-32 cursor-pointer"
          value="drug">
          Medicamentos
        </TabsTrigger>
        <TabsTrigger
          className="data-[state=active]:text-tertiary text-background min-w-32 cursor-pointer"
          value="prescription">
          Anotações
        </TabsTrigger>
      </TabsList>
      <TabsContent value="theme">
        {data.list.filter(
          (item) =>
            item.type === ETypeSearchItem.Theme ||
            item.type === ETypeSearchItem.Topic,
        ).length ? (
          <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
            {data.list
              .filter(
                (item) =>
                  item.type === ETypeSearchItem.Theme ||
                  item.type === ETypeSearchItem.Topic,
              )
              .map((item) => (
                <Link
                  className={cn(
                    'border-primary bg-background text-primary shadow-foreground/50 hover:shadow-foreground/60 flex flex-col justify-between rounded-lg border-2 p-2 text-base font-bold shadow-md transition-all hover:scale-[1.02] lg:px-4 lg:py-2 lg:text-lg',
                  )}
                  key={item.uniqueId}
                  to={`/temas/1/topicos/${item.id}`}>
                  {item.title}
                  <span className="text-secondary text-base">{item.type}</span>
                </Link>
              ))}
          </div>
        ) : (
          <div className="mt-36 flex flex-col justify-center">
            <img
              alt="Imagem de listagem vazia"
              className="mx-auto max-w-80"
              src={emptyPng}
            />
            <p className="mt-4 text-center text-lg font-bold">
              Não há registros!
            </p>
            <p className="mt-4 text-center text-lg">
              Não encontramos temas em nosso sistema
            </p>
          </div>
        )}
      </TabsContent>
      <TabsContent value="drug">
        {data.list.filter((item) => item.type === ETypeSearchItem.Drug)
          .length ? (
          <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
            {data.list
              .filter((item) => item.type === ETypeSearchItem.Drug)
              .map((item) => (
                <Link
                  className={cn(
                    'border-primary bg-background text-primary shadow-foreground/50 hover:shadow-foreground/60 flex flex-col justify-between rounded-lg border-2 p-2 text-base font-bold shadow-md transition-all hover:scale-[1.02] lg:px-4 lg:py-2 lg:text-lg',
                  )}
                  key={item.uniqueId}
                  to={`/medicamentos/${item.id}`}>
                  {item.title}
                  <span className="text-secondary text-base">{item.type}</span>
                </Link>
              ))}
          </div>
        ) : (
          <div className="mt-36 flex flex-col justify-center">
            <img
              alt="Imagem de listagem vazia"
              className="mx-auto max-w-80"
              src={emptyPng}
            />
            <p className="mt-4 text-center text-lg font-bold">
              Não há registros!
            </p>
            <p className="mt-4 text-center text-lg">
              Não encontramos medicamentos em nosso sistema
            </p>
          </div>
        )}
      </TabsContent>
      <TabsContent value="prescription">
        {data.list.filter((item) => item.type === ETypeSearchItem.Prescription)
          .length ? (
          <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
            {data.list
              .filter((item) => item.type === ETypeSearchItem.Prescription)
              .map((item) => (
                <Link
                  className={cn(
                    'border-primary bg-background text-primary shadow-foreground/50 hover:shadow-foreground/60 flex flex-col justify-between rounded-lg border-2 p-2 text-base font-bold shadow-md transition-all hover:scale-[1.02] lg:px-4 lg:py-2 lg:text-lg',
                  )}
                  key={item.uniqueId}
                  to={`/anotacoes/arquivos/${item.id}`}>
                  {item.title}
                  <span className="text-secondary text-base">Anotação</span>
                </Link>
              ))}
          </div>
        ) : (
          <div className="mt-36 flex flex-col justify-center">
            <img
              alt="Imagem de listagem vazia"
              className="mx-auto max-w-80"
              src={emptyPng}
            />
            <p className="mt-4 text-center text-lg font-bold">
              Não há registros!
            </p>
            <p className="mt-4 text-center text-lg">
              Não encontramos anotações em nosso sistema
            </p>
          </div>
        )}
      </TabsContent>
    </Tabs>
  );
}

export default SearchList;
